import React from "react";
import styled from "styled-components";
import BaseComponent from "../BaseComponent";
import PillButton from "./PillButton";
import TestCardBackground from "./TestCardBackground";
import TestDataRenderer from "./TestDataRenderer";
import dateTimeHelper from "../../util/dateTimeHelper";
import { Redirect } from "react-router-dom";
import { Paths } from "../../Constants";

const CardWrapper = styled.div`
  width: 400px;
  border: solid 1px #ccc;
  border-radius: 40px;
  background-color: white;
`;

const PersonalInfoWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  //bottom: 0px;
  margin: 50px;
`;

const FirstName = styled.div`
  color: white;
  font-size: 32px;
  line-height: 32px;
  padding-bottom: 0px;
`;

const LastName = styled.div`
  color: white;
  font-size: 32px;
  line-height: 32px;
  font-weight: bold;
`;
const SafeFunId = styled.div`
  color: white;
  font-size: 20px;
  line-height: 32px;
  padding-bottom: 45px;
`;

const DateOfBirth = styled.div`
  color: white;
  display: inline;
  margin-right: 5px;
`;

const DateOfBirthValue = styled.div`
  color: white;
  font-weight: bold;
  display: inline;
`;

const DayTime = styled.div`
  //margin-top: 60px;
`;

const DataRendererWrapper = styled.div`
  margin: 20px 0 20px 0;
`;

const WindowReason = styled.div`
  margin: 20px 0 30px 0;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

class TestCard extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      consumer: null,
      results: [],
    };

    this.validWindowDate = this.validWindowDate.bind(this);
    this.windowDate = this.windowDate.bind(this);
  }

  async componentDidMount() {
    this.setState({ consumer: this.props.consumer });
    const results = [];
    if (this.validWindowDate(this.props.consumer.strongSafetyDate)) {
      results[0] = {
        strength: "Strong",
        date: dateTimeHelper.windowDate(this.props.consumer.strongSafetyDate),
      };
    }
    if (this.validWindowDate(this.props.consumer.weakSafetyDate)) {
      results[results.length + 1] = {
        strength: "Weak",
        date: dateTimeHelper.windowDate(this.props.consumer.weakSafetyDate),
      };
    }

    this.setState({ results });
  }

  validWindowDate(dateValue) {
    return dateValue != null && new Date(dateValue) > new Date();
  }

  windowDate(dateValue) {
    const date = new Date(dateValue);
    return (
      dateTimeHelper.getDayOfWeek(date) +
      ", " +
      (date.getMonth() + 1) +
      "/" +
      date.getDate() +
      ", " +
      (date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) +
      ":" +
      date.getMinutes() +
      (date.getHours() > 12 ? "pm" : "am")
    );
  }

  render() {
    return (
      <CardWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        {this.state.consumer ? (
          <>
            <div style={{ height: "243px" }}>
              <TestCardBackground
                strong={this.validWindowDate(
                  this.state.consumer.strongSafetyDate
                )}
                weak={this.validWindowDate(this.state.consumer.weakSafetyDate)}
              />
              <PersonalInfoWrapper>
                <FirstName>{this.state.consumer.firstName}</FirstName>
                <LastName>{this.state.consumer.lastName}</LastName>
                <SafeFunId>{this.state.consumer.safeFunId}</SafeFunId>
                {this.props.currentUser ? (
                  <>
                    <DateOfBirth>DOB</DateOfBirth>
                    <DateOfBirthValue>
                      {dateTimeHelper.formatDate(this.state.consumer.dob)}
                    </DateOfBirthValue>
                  </>
                ) : null}
              </PersonalInfoWrapper>
            </div>
            <div style={{ margin: "0 30px" }}>
              {this.state.results.length > 0 && (
                <DayTime>SafeWindow Day &amp; Time</DayTime>
              )}
              <DataRendererWrapper>
                {!this.state.results.length > 0 ? (
                  <div>
                    No valid test results within the required SafeWindows.
                    <br />
                    {this.props.currentUser ? (
                      <>
                        Please upload a new test result.
                        <CenteredButtonWrapper>
                          <PillButton
                            onClick={() => {
                              this.redirect(Paths.MY_TESTS);
                            }}
                            primary
                            style={{ width: "200px" }}
                          >
                            Submit Test
                          </PillButton>
                        </CenteredButtonWrapper>
                      </>
                    ) : null}
                  </div>
                ) : (
                  <>
                    {this.state.results.map((result, idx) => {
                      return (
                        <TestDataRenderer
                          strength={result.strength}
                          date={result.date}
                          key={idx}
                        />
                      );
                    })}
                  </>
                )}
              </DataRendererWrapper>
              {this.state.results.length > 0 ? (
                <WindowReason>
                  {this.state.consumer.safeWindowDescription}
                </WindowReason>
              ) : null}
            </div>
          </>
        ) : null}
      </CardWrapper>
    );
  }
}

export default TestCard;
